export default __webpack_public_path__ + "static/minima-865732c284a34984fc77ac913f3f2ba1.svg";